export const data = [
    {
        id: "0",
        question: "What happens during the build season?",
        answer: "Teams have around 6 weeks to build their robot and code it.",
        variants: [`Teams have 6 weeks to disassemble their previous year's robot.`, `Teams have around 6 weeks to build their robot and code it.`, `Teams participate in competitions to earn district points.`, `Teams accept new members and ask them to build a robot.`]
    },
    {
        id: "1",
        question: "What is kickoff?",
        answer: "An event held in early January that announces the new FRC game for the year.",
        variants: [`An event where FRC teams mail off their robot to compete.`, `An event held to celebrate the start of the NFL season.`, `An event held in June to celebrate the end of competitions.`, `An event held in early January that announces the new FRC game for the year.`]
    },
    {
        id: "2",
        question: "What is the competition season?",
        answer: "A time when teams compete with other teams at competitions.",
        variants: [`A time when teams compete with other teams at competitions.`, `Team members compete to elect their next executive board.`, `A time when teams compete internally to decide the best robot to send off.`, `Team members compete with each others to design the best robot.`]
    },
    {
        id: "3",
        question: "What is one thing that is typically done during the off-season?",
        answer: "Iterate and design new technologies that were previously impossible during the competition season.",
        variants: [`Have a big disagreement and quit the club.`, `Burn the robot.`, `Iterate and design new technologies that were previously impossible during the competition season.`, `Take a long break and disband the club for the period.`]
    },
]

// {
//     id: "3",
//     question: "",
//     answer: "",
//     variants: [``, ``]
// },